/**
 * Type of action which sets the current state of noise suppression.
 *
 * {
 *     type: SET_NOISE_SUPPRESSION_ENABLED,
 *     enabled: boolean
 * }
 */
export const SET_NOISE_SUPPRESSION_ENABLED = 'SET_NOISE_SUPPRESSION_ENABLED';
export const SET_NOISE_SUPPRESSION_ENABLED_STATE_ONLY = 'SET_NOISE_SUPPRESSION_ENABLED_STATE_ONLY';
